import { EMPTY_LIST } from '../../../constants/common'
import { ARROW_LEFT_KEY, ARROW_RIGHT_KEY } from '../../../constants/key'

function getFocusableOptions(container) {
  return Array.from(container.querySelectorAll('button:not([disabled])'))
}

function getArrowStep(key) {
  return key === ARROW_RIGHT_KEY ? 1 : key === ARROW_LEFT_KEY ? -1 : 0
}

export function getRentalPortalViewRegimeNextArrowOption({
  container,
  key,
  target,
}) {
  const step = getArrowStep(key)

  const options = step === 0 ? EMPTY_LIST : getFocusableOptions(container)

  return options[options.indexOf(target) + step]
}

export function getIsRentalPortalViewRegimeOptionInert({
  listViewType,
  option,
}) {
  return option.value === listViewType
}
